interface ClusterData {
  id: string | number
  name: string
  description: string
  status?: string
  created_at?: string
  date_added?: string
}

interface BaseFormInput {
  name: string
  prompt: string
  placeholder: string
  required: boolean
  initialValue: string
}

interface TextFormInput extends BaseFormInput {
  inputType: "text"
  rules: { required: boolean }
  isFullWidth: boolean
}

type FormInput = TextFormInput

export const TableKeys = ["clusterName", "description", "status", "dateAdded"]

export const TableHeaders = ["Cluster Name", "Description", "Status", "Date Added"]

export const TableData = (clusters: ClusterData[]) => {
  return (
    clusters?.map((cluster: ClusterData) => {
      const isActive = cluster.status?.toLowerCase() === "active"

      return {
        id: cluster.id,
        clusterName: { value: cluster.name, type: "string" },
        description: { value: cluster.description, type: "string" },
        status: {
          value: isActive ? "Active" : "Inactive",
          type: "status",
          statusType: isActive ? "active" : "inactive",
        },
        dateAdded: {
          value: new Date(cluster.created_at || cluster.date_added || "").toLocaleDateString(),
          type: "string",
        },
      }
    }) || []
  )
}

export const getFormInputs = (cluster?: ClusterData | null): FormInput[] => [
  {
    inputType: "text",
    name: "name",
    prompt: "Cluster Name",
    placeholder: "Enter Cluster Name",
    rules: { required: true },
    isFullWidth: true,
    required: true,
    initialValue: cluster?.name || "",
  },
  {
    inputType: "text",
    name: "description",
    prompt: "Cluster Description",
    placeholder: "Enter Description",
    rules: { required: true },
    isFullWidth: true,
    required: true,
    initialValue: cluster?.description || "",
  },
]
